export default {
  // 3-3
  workArea_facList: [],
  workArea_locationList: [],
  workArea_fabList: [],
  workArea_all: [],
  workArea_allList: [],

  signoff_areaType: [],
  signoff_secondAreaList: [],
  signoff_workerList: [],
  signoff_all: [],
  signoff_allList: [],
  signoff_detail: [],

  // 3-4~3-5
  facList_all: [],
  room_all: [],
  room_allList: [],

  nonDustless_fabList: [],
  dustless_fabList: [],

  // 3-6
  highrisk_all: [],
  highrisk_allList: [],

  // 3-12
  contract_all: [],
  contract_allList: [],
};
